import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import CreateDivisionForm from "./CreateDivisionForm";
import { PlusSquare } from "react-feather";

interface CreateDivisionModalProps {
  company_code: string;
}

const CreateDivisionModal: React.FC<CreateDivisionModalProps> = ({
  company_code,
}) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Btn
        color="primary"
        onClick={toggle}
        style={{ display: "flex", alignItems: "center", gap: "2px" }}
      >
        <PlusSquare size={16} />
        Create New Division
      </Btn>
      <Modal isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Create New Division</H3>
            <P className="f-w-300" style={{ margin: 0 }}>
              Fill in the details below.
            </P>
          </ModalHeader>

          <CreateDivisionForm company_code={company_code} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};
export default CreateDivisionModal;
